export default {
    createErrorFromXhr(xhr, msg = 'An unexpected error occurred.') {
        let message = msg;

        if (xhr.responseJSON) {
            if (xhr.responseJSON.msg) {
                message = xhr.responseJSON.msg;
            }
        }

        const err = new Error(message);

        if (xhr.status === 404) {
            err.name = "NotFoundError";
        }

        return err;
    }
}
